module.exports = __webpack_public_path__ + "static/media/bike2_800x500.389cce34.jpg";